<template>
    <div class="ss-live-page">
        <banner-video :vm="accomplishmentBanmer"></banner-video>
        <div class="production-container">
            <section-title :main="productionData.main" :sub="productionData.sub"></section-title>
            <img class="production-img" :src="productionData.image1" alt="">
        </div>

        <div class="why-container">
            <section-title :main="whyData.main" :sub="whyData.sub"></section-title>
            <img class="why-img" :src="whyData.image" alt="">
        </div>

        <div class="my-container">
            <section-title :main="myData.main" :sub="myData.sub"></section-title>
            <ul class="scene-list">
                <li v-for="item in myData.list" :key="item.title">
                    <img :src="item.bg" alt="">
                    <p>{{ item.title }}</p>
                    <p>{{ item.content }}</p>
                </li>
            </ul>
        </div>

    </div>
</template>
<script>
import bannerVideo from './components/banner-video'
import { accomplishmentBanmer } from '@/const'
export default {
    data () {
        return {
            accomplishmentBanmer: accomplishmentBanmer,
            productionData: {
                main: '我们的产品',
                sub: '',
                image1: require('@/assets/coursetype/suyang/my-production.png')
            },
            whyData: {
                main: '为什么选择我们',
                sub: '',
                image: require('@/assets/coursetype/suyang/choice-me.png')
            },
            myData: {
                main: '我们的内容',
                sub: '',
                list: [
                    {
                        bg: require('@/assets/coursetype/suyang/content-1.png'),
                        title: 'STEAM',
                        content: '以STEAM模式代替传统教学，助力孩子主动探索和独立思考'
                    },
                    {
                        bg: require('@/assets/coursetype/suyang/content-2.png'),
                        title: '分级阅读',
                        content: ' 文学、科幻、侦探…多主题相互交叉融合，帮助孩子多角度认识更广阔的的世界'
                    },
                    {
                        bg: require('@/assets/coursetype/suyang/content-3.png'),
                        title: '数独',
                        content: '逻辑推理、思考力、专注力、洞察力、反应力、记忆力，六大能力全覆盖'
                    },
                    {
                        bg: require('@/assets/coursetype/suyang/content-4.png'),
                        title: '写字课',
                        content: '写字课 科学设计，循序渐进，实用与审美相'
                    },
                    {
                        bg: require('@/assets/coursetype/suyang/content-5.png'),
                        title: '美术课',
                        content: '学习美术基础知识，培养创意设计，激发好奇心和想象力，初步进行平面和立体构建'
                    },
                    {
                        bg: require('@/assets/coursetype/suyang/content-6.png'),
                        title: '无人机',
                        content: '趣味性飞行课程安排，分阶段操控联系，锻炼孩子的手、脑、眼并用能力'
                    },
                    {
                        bg: require('@/assets/coursetype/suyang/content-7.png'),
                        title: '编程',
                        content: '通过Scratch、Python等图形化编程工具学习，寓教于乐，锻炼孩子逻辑思维'
                    },
                    {
                        bg: require('@/assets/coursetype/suyang/content-8.png'),
                        title: '研学',
                        content: '已麦斯的太空之旅为线索，涵盖三大视野拓展课程，三大宇宙探索工具和三大嘉年华趣味活动'
                    },
                ]
            }
        }
    },
    components: { bannerVideo}
}
</script>

<style lang="scss" scoped>
    .production-container {
        .section-title-box {
            padding-bottom: 0;
        }
        img {
            width: 335px;
        }
        .production-img {
            margin-top: 40px;
        }
    }
    .why-img {
        width: 352px;
    }
    .scene-list {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        padding: 0 20px;
        justify-content: space-between;
        li {
            padding-top: 10px;
            width: 162px;
            img {
                width: 162px;
            }
            p {
                text-align: left;
            }
            p:nth-of-type(1) {
                padding-top: 10px;
                font-size: 16px;
                font-weight: 600;
                color: #282828;
                line-height: 18px;
            }
            p:nth-of-type(2) {
                padding-top: 6px;
                font-size: 12px;
                color: #282828;
                line-height: 18px;
            }
        }
        li:nth-of-type(1),
        li:nth-of-type(2) {
            padding-top: 0;
        }
    }

    .tese-list {
        padding: 0 20px;
        li {
            display: flex;
            flex-direction: row;
            padding-top: 40px;
            img {
                width: 36px;
            }
            .right {
                padding-left: 16px;
                p {
                    text-align: left;
                }
                p:nth-of-type(1) {
                    font-size: 16px;
                    font-family: PingFangSC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #202428;
                    line-height: 16px;
                }
                p:nth-of-type(2) {
                    padding-top: 8px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #8E9DAE;
                    line-height: 21px;
                }
            }
        }
        li:nth-of-type(1) {
            padding-top: 0;
        }
    }
</style>
